<template>
  <div class="candidate-page">
    <div class="candidate-page__main">
      <DetailViewGroupFields
        v-for="item in panels"
        :key="`${item.panel_id}_${fields.id.value}`"
        :panel="item"
        :fields="fields"
        store-module="candidate"
      />
    </div>
    <div class="candidate-page__subpanels">
      <Subpanel
        :name="subpanels.length"
        v-if="subpanels.length"
        :tabs="subpanels"
        :emails="emails"
        :allowed-scroll="true"
        :key="fields.id.value"
        module="HRPAC_CANDIDATES"
        class="subpanels"
      >
      </Subpanel>
    </div>

    <Meetings v-if="meetings.length" />
  </div>
</template>
<script>
import { store } from '@/store';
import { getVal, detailView } from '@/utils/helpers';
import { MODULE } from '@/utils/constants';
import { mixin, errorMsg, detailViewPage } from '@/utils/mixins';
import DetailViewGroupFields from 'Elements/MetaData/DetailViewGroupFields';
import Meetings from 'Elements/Meetings/Meetings';

export default {
  mixins: [mixin, errorMsg, detailViewPage],
  props: {
    fields: {
      type: Object
    },
    mod: {
      type: Object
    },
    data: {
      type: Object,
      default: null
    },
    metaData: {
      type: Object,
      default: null
    },
    previewAllowed: {
      type: Boolean,
      default: false
    },
    module: String,
    config: Object,
    panels: {
      type: Array,
      default: null
    },
    subpanels: {
      type: Array,
      default: null
    },
    buttons_menu: {
      type: Array,
      default: null
    },
    loading: Boolean,
    options: {
      type: Object,
      default() {
        return {};
      }
    },
    emails: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  computed: {
    meetings() {
      return store.state.candidate.meetings || [];
    },
    // subpanels() {
    //   return store.state.subpanels.subpanels;
    // },

    viewRoute() {
      return detailView(MODULE.CANDIDATES_MODULE, 'id');
    },
    isDisabled() {
      return {
        btn: {
          edit: false,
          // delete: Boolean(this.data.length),
          // generate_link: !this.data.length,
          // send_mail:
          //   !this.fields.communications.value ||
          //   !this.fields.communications.value.filter(
          //     ({ value_type }) => value_type === 'email'
          //   ).length,
          share_candidate_in_telegram: false,
          // form_offer: this.offerBtnDisabled,
          add_tag: store.state.candidate.visible.tagForm || false
          // open_questionnaire: !this.fields.questionnaire.value,
          // form_exit_request: this.exitRequestBtnDisabled
        }
      };
    },
    offerBtnDisabled() {
      // блочим если нет привязанных вакансий,
      // нет доступа,
      // есть доступ если единственная вакансия на текущем этапе с галкой
      // даем доступ если Оффер пройден
      // блочим если несколько вакансий на текущем этапе с галкой (не считая пройденных этапов с галкой), независимо от наличия сформированного оффера
      return !this.data.length || !this.config.hasOfferAccess;
    },
    exitRequestBtnDisabled() {
      // доступность кнопок оффер и заявка на выход привязать к текущему или пройденному этапу
      return (
        !this.data.length ||
        !Object.values(this.config.exitStages).filter(val => val.length).length
      );
    },

    updateContactsKey() {
      return store.state.candidate.updateContactsKey || 0;
    }
  },
  methods: {
    closeCard() {
      this.$router.push('/candidates');
    },
    initMeetingDialog() {
      store.commit('common/setVisibleDialog', {
        name: 'meeting_dialog',
        val: true
      });
    },
    getValue(name, defaultVal) {
      return getVal(this.fields, this.data, name, defaultVal);
    }
  },
  components: {
    Subpanel: () => import('Elements/Subpanel/Subpanel.vue'),
    DetailViewGroupFields,
    Meetings
  }
};
</script>
<style lang="scss">
.candidate-page {
  overflow-y: hidden;
  width: inherit;
  max-width: inherit;
  text-align: left;
  background-color: $white;

  &__subpanels {
    border-radius: 0 0 4px 4px;

    .doubles-tab__subpanel {
      .el-tabs__header {
        width: fit-content;
      }
    }

    .el-tabs__header {
      margin: 0 24px !important;
    }
  }

  &__main {
    width: 100%;

    padding: 24px 24px 0 24px;
  }

  & > .tab-bar {
    margin-top: 24px;
  }
}

.candidate-page__main {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

// табы
.tab-bar {
  align-items: flex-start;
  font-size: 18px !important;
}

// резюме таба
.candidate-info {
  text-align: left;

  .gray_text {
    color: $black-40;
  }

  .candidate-info_update {
    color: $black-40;
    margin-top: 25px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 24px;
  }

  .vacancy-price {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    color: $black-170;
  }

  .vacancy {
    font-style: normal;
    font-weight: normal;
    font-size: 40px;
    line-height: 48px;
    position: static;
    /* width: 711px; */
    flex-grow: 0;
    color: $black-170;
    flex: none;
    order: 2;
    text-align: left;
    margin-bottom: 24px;
  }

  .vacancy-link {
    text-align: center;
  }

  .candidate-educ_box {
    display: flex;
    flex-direction: row;
    text-align: left;
  }

  .candidate-educ {
    width: 518px;
  }

  .skill-box {
    margin: 8px 0 8px 0;
  }

  .candidate-skills {
    text-align: left;
    display: inline-block;
  }

  .skills {
    color: $black-70;
    background: $black-10;
    border: 1px solid $black-30;
    box-sizing: border-box;
    border-radius: 4px; //10
    flex-grow: 0;
    display: inline-block;
    margin: 0px 4px 8px 0;
    padding: 0px 8px;
    font-size: 16px;
    white-space: nowrap;
  }

  .text_bond {
    font-weight: bold;
    font-size: 16px;
  }

  .candidate-work-time {
    width: 139px;
  }

  .candidate-work-place {
    width: 548px;
    margin-left: 25px;
  }

  .candidate-work {
    display: flex;
    flex-direction: row;
    text-align: left;
    margin-top: 32px;
  }

  .candidate-big-gray {
    color: $black-40;
    text-align: left;
  }

  .candidate-big {
    font-weight: bold;
    font-size: 24px;
  }

  .price {
    white-space: nowrap;
  }
}

.area-middle-item:not(:last-child) {
  margin-right: 35px;
}

.area-middle-item:last-child {
  overflow: hidden;
}

.area-middle-item svg {
  min-width: 24px;
}
</style>
